import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Star, MapPin } from 'lucide-react';

export const SubServicesList = ({ items }) => (
  <div className="grid sm:grid-cols-2 gap-4">
    {items.map((s, i) => (
      <div key={i} className="flex items-center gap-3 p-3 bg-neutral-50 rounded-lg">
        <CheckCircle className="w-5 h-5 text-amber-500 flex-shrink-0" />
        <span className="text-neutral-700 font-medium">{s}</span>
      </div>
    ))}
  </div>
);

export const TagsList = ({ items }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((n, i) => (
      <span key={i} className="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-full text-sm font-medium">{n}</span>
    ))}
  </div>
);

export const ServiceTestimonial = ({ text, author, neighborhood, cityName }) => (
  <section className="bg-neutral-900 rounded-2xl p-8">
    <div className="flex gap-1 mb-4">
      {[1,2,3,4,5].map(i => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />)}
    </div>
    <p className="text-white text-lg italic mb-4">"{text}"</p>
    <div className="text-amber-400 font-semibold">{author}</div>
    <div className="text-neutral-400 text-sm">{neighborhood}, {cityName}</div>
  </section>
);

export const ServiceFAQs = ({ faqs }) => (
  <div className="space-y-3">
    {faqs.map((faq, i) => (
      <details key={i} className="bg-neutral-50 rounded-lg border group">
        <summary className="px-5 py-4 cursor-pointer font-semibold text-neutral-800 hover:text-amber-600 list-none flex items-center justify-between">
          {faq.q}
          <svg className="w-4 h-4 text-neutral-400 group-open:rotate-180 transition-transform flex-shrink-0 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </summary>
        <div className="px-5 pb-4 text-neutral-600">{faq.a}</div>
      </details>
    ))}
  </div>
);

export const SmallTagsList = ({ items }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((z, i) => (
      <span key={i} className="px-3 py-1 bg-white border rounded text-sm text-neutral-600">{z}</span>
    ))}
  </div>
);

export const OtherCityLinks = ({ cities, serviceId }) => (
  <ul className="space-y-2">
    {cities.map(c => (
      <li key={c.slug}>
        <Link to={`/services/${serviceId}/${c.slug}`} className="text-amber-600 hover:text-amber-700 text-sm font-medium flex items-center gap-1">
          <MapPin className="w-3 h-3" /> {c.name}, TX
        </Link>
      </li>
    ))}
  </ul>
);
